export function OverlayScrollbarsSet() {
  let {
    OverlayScrollbars,
    ScrollbarsHidingPlugin,
    SizeObserverPlugin,
    ClickScrollPlugin,
  } = OverlayScrollbarsGlobal;

  // 必要に応じてimportまたは直接使用

  // オプションの書き方JavaScript;
  const osInstance = OverlayScrollbars(document.querySelector("body"), {
    //以下オプションはすべてデフォルト値
    paddingAbsolute: false,
    showNativeOverlaidScrollbars: false,
    update: {
      elementEvents: [["img", "load"]],
      debounce: [0, 33],
      attributes: null,
      ignoreMutation: null,
    },
    overflow: {
      x: "scroll",
      y: "scroll",
    },
    scrollbars: {
      theme: "os-theme-dark",
      visibility: "auto",
      autoHide: "never",
      autoHideDelay: 1300,
      dragScroll: true,
      clickScroll: false,
      pointers: ["mouse", "touch", "pen"],
    },
  });
}
